@use "stylesheets/utility/variables";

.footerWrapper {
  padding-bottom: variables.$page-footer-height;
  @media (max-width: variables.$laptop) {
    padding-bottom: variables.$page-footer-height-sm;
  }
}

.container {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: var(--bg-canvas);
  font-size: variables.$small-text-size;
  @media (min-width: variables.$laptop) {
    border-top: 1px solid var(--border-default);
  }

  .flexWrapper {
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: variables.$page-footer-height;

    @media (max-width: variables.$laptop) {
      flex-wrap: wrap;
      justify-content: center;
      height: variables.$page-footer-height-sm;
    }
  }

  .content {
    display: flex;
    align-items: center;
    position: relative;
    margin: 0 auto;
    left: -54px;

    @media (max-width: variables.$laptop) {
      order: 2;
      flex: 1 0 100%;
      justify-content: center;
      flex-wrap: wrap;
      left: 0;
    }
  }

  .sitemap {
    list-style: none;
    display: flex;
    margin: 0;
    padding: 0;

    li {
      padding: 0 10px;
    }

    @media (max-width: variables.$tabletS) {
      margin-bottom: 15px;
    }
  }

  .text {
    color: var(--text-default);
    padding: 0 10px;

    @media (max-width: variables.$tabletS) {
      order: 1;
      margin-bottom: 15px;
    }
  }

  .msslogo {
    width: 122px;
    @media (max-width: variables.$laptop) {
      order: 3;
    }
  }

  .bar {
    @media (max-width: variables.$laptop) {
      display: none;
    }
  }
}
